import React from "react";
import { SnackbarContent, CustomContentProps } from "notistack";

const CustomDefaultSnackbar = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {
  const { message, id, ...other } = props;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <SnackbarContent
        ref={ref}
        id={id?.toString()}
        {...other}
        style={{
          backgroundColor: "white",
          color: "black",
          padding: "16px 20px",
          fontSize: "1rem",
          fontWeight: "500",
          lineHeight: "1.5",
          fontFamily: "var(--font-sans)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          width: "fit-content",
          minWidth: "unset",
          maxWidth: "unset",
        }}
      >
        {message}
      </SnackbarContent>
    </div>
  );
});

CustomDefaultSnackbar.displayName = "CustomDefaultSnackbar";

export default CustomDefaultSnackbar;
